module.exports = __webpack_public_path__ + "img/diagram_23_1.cc9b24ff.png";